function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.61 13.999c.922 3.963 4.524 6.998 8.93 7.341A9.916 9.916 0 0112 22C6.486 22 2 17.514 2 12S6.486 2 12 2c1.248 0 2.438.24 3.541.66-4.407.344-8.008 3.377-8.931 7.341v.043a8.253 8.253 0 000 3.912V14zM18.004 4.02C20.425 5.85 22 8.74 22 12s-1.575 6.151-3.996 7.979a9.441 9.441 0 01-1.629.146c-1.72 0-3.321-.47-4.675-1.269.1.006.199.019.3.019 3.106 0 5.625-3.078 5.625-6.875 0-3.798-2.519-6.875-5.625-6.875-.101 0-.2.013-.3.019a9.185 9.185 0 016.304-1.123z"
});

var SvgBrowserOpera = function SvgBrowserOpera(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/browser-opera.78667ccc.svg";
export { SvgBrowserOpera as ReactComponent };